import React, { useState } from 'react';

import { Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, CircularProgress } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

export default props => {
  const classes = useStyles();
  const [panelDetails, setPanelDetails] = useState({});

  const handleChange = detailsKey => (event, isExpanded) => {
    if (isExpanded) {
      setPanelDetails({ ...panelDetails, [detailsKey]: props.panels[detailsKey].details });
    }
  };

  return (
    <div className={classes.root}>
      {props.panels.map((panel, i) => (
        <ExpansionPanel key={i} onChange={handleChange(i)}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>{panel.heading}</Typography>
            {panel.secondaryHeading ? <Typography className={classes.secondaryHeading}>{panel.secondaryHeading}</Typography> : null}
          </ExpansionPanelSummary>
          {panelDetails[i] ? <ExpansionPanelDetails>{panelDetails[i]}</ExpansionPanelDetails> : <CircularProgress />}
        </ExpansionPanel>
      ))}
    </div>
  );
};
